import request from "root/js/request";

const getHeatMapAsTable = async ({
  wb_api_key_ids,
  date_from,
  date_to,
  advert_id__in,
  brand_id__in,
  category_id__in,
  subject_id__in,
  product_id__in,
  filter_by_advert_stat,
}) => {
  const response = await request({
    url: "/analytics/advert_heat_map/as_table/",
    method: "get",
    params: {
      wb_api_key_ids,
      date_from,
      date_to,
      advert_id__in,
      brand_id__in,
      category_id__in,
      subject_id__in,
      product_id__in,
      filter_by_advert_stat,
    },
  });
  return response.data;
};

export { getHeatMapAsTable };
